import { onBeforeUnmount } from 'vue';
import { debounce } from '@/utils/api';
import { DEVICE_RESIZE_DELAY } from '@rebuild/hooks/useDeviceResize';

/**
 * 图表自适应 resize hook
 * @param {Object|Function} chartInstance - ECharts 实例或返回实例的函数
 * @param {Number} delay - 防抖延迟时间（毫秒），默认 50ms
 * @returns {Object} { resizeHandler, startListening, stopListening }
 */
export function useChartResize(chartInstance, delay = DEVICE_RESIZE_DELAY) {
	const getChartInstance = () => {
		return typeof chartInstance === 'function' ? chartInstance() : chartInstance;
	};

	const resizeHandler = debounce(() => {
		const instance = getChartInstance();
		if (instance && typeof instance.resize === 'function') {
			instance.resize();
		}
	}, delay);

	const startListening = () => {
		window.addEventListener('resize', resizeHandler);
	};

	const stopListening = () => {
		window.removeEventListener('resize', resizeHandler);
	};

	// 组件卸载时自动移除监听
	onBeforeUnmount(() => {
		stopListening();
	});

	return {
		resizeHandler,
		startListening,
		stopListening
	};
}
